import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ContactTemp} from '../../../entities/contact-temp.model';
import {ColumnMode, DatatableComponent} from '@swimlane/ngx-datatable';
import {Contact} from '../../../entities';
import {SalesunitTemp} from '../../../entities/salesunit-temp.model';
import {JhiLanguageService} from 'ng-jhipster';
import {Observable} from 'rxjs/Observable';
import { LocalStorageService } from 'ng2-webstorage';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TRAINING } from '../../../app.constants';
import {MerchantChange} from '../../../entities/merchant-change.model';
import {plainToClass} from 'class-transformer';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styles: []
})
export class CompanyDetailComponent implements OnInit {

  @ViewChild('companiesTable') companiesTable: DatatableComponent;
  rowsCompanies = [];

  @ViewChild('personTable') personTable: DatatableComponent;
  rowsPersons = [];

  @ViewChild('salesunitTable') salesunitTable: DatatableComponent;
  rowsSalesunits = [];

  loadingIndicatorCompanies = true;
  loadingIndicatorPersons = true;
  loadingIndicatorSalesunits = true;

  contact: Contact;

  archive: boolean;
  useLastMarketDetail: boolean;
  lastMarketDetail: string;
  lastMarketDetailTitle: string;

  modalRef: any = null;
  @ViewChild('newCompanyModal') private newCompanyModal;

  trainingSystem = TRAINING;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private jhiLanguageService: JhiLanguageService,
              public router: Router,
              private localStorage: LocalStorageService,
              private modalService: NgbModal) {
    this.jhiLanguageService.setLocations(['base-data']);
    this.archive = this.router.url.split('/company')[0] === '/base-data-archive';
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const contactId = +params['id'];
      this.load(contactId);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.useLastMarketDetail = (queryParams && queryParams['useLastMarketDetail']) || false;
      if (this.useLastMarketDetail) {
        this.lastMarketDetail = this.localStorage.retrieve('lastMarketDetail');
        this.lastMarketDetailTitle = this.localStorage.retrieve('lastMarketDetailTitle');
      }
    });
  }

  setDataTableColumnModeToForce(table: 'personTable' | 'salesunitTable' | 'companiesTable') {
    switch (table) {
      case 'personTable':
        if (this.personTable) {
          this.personTable.columnMode = ColumnMode.force;
        } else {
          setTimeout(() => {
            this.setDataTableColumnModeToForce('personTable');
          }, 100);
        }
        break;
      case 'salesunitTable':
        if (this.salesunitTable) {
          this.salesunitTable.columnMode = ColumnMode.force;
        } else {
          setTimeout(() => {
            this.setDataTableColumnModeToForce('salesunitTable');
          }, 100);
        }
        break;
      case 'companiesTable':
        if (this.companiesTable) {
          this.companiesTable.columnMode = ColumnMode.force;
        } else {
          setTimeout(() => {
            this.setDataTableColumnModeToForce('companiesTable');
          }, 100);
        }
        break;
      default:
        break;
    }
  }

  load(id: number) {
    return Promise.all([
      this.loadContactTemp(id),
      this.loadSalesunitTemp(id),
      this.loadContact(id),
    ]).then(() => {
      this.loadingIndicatorCompanies = false;
      this.loadingIndicatorPersons = false;
    });
  }

  loadContactTemp(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.find<ContactTemp>(ContactTemp, 'contact-temps-changes/' + id + '/false/' + this.archive.toString()).subscribe(
        contactTemps => {
          this.rowsCompanies = contactTemps.filter(item =>
            (item.status === 'After' || item.status === 'New') && item.casIsCompany);
          this.rowsPersons = contactTemps.filter(item =>
            (item.status === 'After' || item.status === 'New') && item.casIsContact && !item.casIsCompany);

          if (this.archive) {
            this.rowsCompanies.sort((c1: ContactTemp, c2: ContactTemp) => this.compareDate(c1.updated, c2.updated, true));
            this.rowsPersons.sort((c1: ContactTemp, c2: ContactTemp) => this.compareDate(c1.updated, c2.updated, true));
          } else {
            this.rowsCompanies.sort((c1: ContactTemp, c2: ContactTemp) => this.compareDate(c1.updated, c2.updated));
            this.rowsPersons.sort((c1: ContactTemp, c2: ContactTemp) => this.compareDate(c1.updated, c2.updated));
          }

          this.setDataTableColumnModeToForce('personTable');
          this.setDataTableColumnModeToForce('companiesTable');

          this.loadContactWeb(id).then(() => resolve()).catch((err) => {
            console.log('No merchant-changes to load! ', err);
            resolve();
          });
        }
      );
    });
  }

  loadSalesunitTemp(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.find<SalesunitTemp>(SalesunitTemp, 'salesunit-temps-changes/' + id + '/' + this.archive.toString()).subscribe(
        salesunitTemps => {
          this.rowsSalesunits = salesunitTemps.
          filter(item => item.status === 'After' || item.status === 'New' || item.status === 'Deleted');
          this.loadingIndicatorSalesunits = false;
          this.setDataTableColumnModeToForce('salesunitTable');

          if (this.archive) {
            this.rowsSalesunits.sort((s1: SalesunitTemp, s2: SalesunitTemp) => this.compareDate(s1.updated, s2.updated, true));
          } else {
            this.rowsSalesunits.sort((s1: SalesunitTemp, s2: SalesunitTemp) => this.compareDate(s1.updated, s2.updated));
          }
          resolve();
        }
      );
    });
  }

  loadContact(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.findOne<Contact>(Contact, 'contacts/' + id).subscribe(contact => {
        this.contact = contact;
        resolve();
      });
    });
  }

  loadContactWeb(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService.findOne<ContactTemp>(ContactTemp,
        'backoffice/merchant-changes-by-original-contact/' + id + '/' + this.archive.toString())
        .subscribe((merchantChange) => {
          if (!merchantChange) { resolve(); }
          merchantChange.status = 'After';
          if (!this.rowsCompanies.some((item) => item.originalContact.id === merchantChange.originalContact.id)) {
            this.rowsCompanies.push(merchantChange);
          }
          if (!this.rowsCompanies.some((item: ContactTemp) => item.originalContact.id === merchantChange.originalContact.id)) {
            this.rowsCompanies.push(merchantChange);
          }
          resolve();
        }, e => {
          reject(e);
        });
    });
  }

  compareDate(d1, d2, desc = false) {
    if (d1 < d2) {
      return (desc ? 1 : -1);
    }
    if (d1 > d2) {
      return  (desc ? -1 : 1);
    }
    return 0;
  }

  onSelectMerchant(event) {
    const targetUrl = (this.archive) ? '/base-data-archive/company/' + this.contact.id + '/contact'
                                     : '/base-data/company/' + this.contact.id + '/contact';
    this.router.navigate([targetUrl, event.selected[0].originalContact.id], {queryParamsHandling: 'preserve'})
      .then(() => {});
  }

  onSelectContactPerson(event) {
    if (this.newCompany() && !this.archive && !this.trainingSystem) {
      this.openModal(this.newCompanyModal, {size: 'sm', windowClass: 'm'});
    } else {
      const targetUrl = (this.archive) ? '/base-data-archive/company/' + this.contact.id + '/contact'
        : '/base-data/company/' + this.contact.id + '/contact';
      this.router.navigate([targetUrl, event.selected[0].originalContact.id], {queryParamsHandling: 'preserve'})
        .then(() => {});
    }
  }

  onSelectSalesunit(event) {
    if (this.newCompany() && !this.archive && !this.trainingSystem) {
      this.openModal(this.newCompanyModal, {size: 'sm', windowClass: 'm'});
    } else if (event.selected[0].statusArchive === 'ArchiveDuplicate' || event.selected[0].statusArchive === 'ArchiveRevoked') {

    } else {
      const targetUrl = (this.archive) ? '/base-data-archive/company/' + this.contact.id + '/salesunit'
        : '/base-data/company/' + this.contact.id + '/salesunit';
      this.router.navigate([targetUrl, event.selected[0].originalSalesunit.id], {queryParamsHandling: 'preserve'})
        .then(() => {
        });
    }
  }

  getContactByUserId(userId: number): Observable<Contact | null> {
    if (userId) {
      return this.apiService.findOne<Contact>(Contact, 'contact-by-user/' + userId);
    } else {
      return Observable.create(observer => observer.next(null));
    }
  }

  newCompany(): boolean {
    return this.rowsCompanies.some(merchant => merchant.status === 'New');
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  goToNewMerchant() {
    const targetUrl = (this.archive) ? '/base-data-archive/company/' + this.contact.id + '/contact'
      : '/base-data/company/' + this.contact.id + '/contact';
    this.router.navigate([targetUrl, this.rowsCompanies[0].originalContact.id],
      {queryParams: (this.useLastMarketDetail) ? {'useLastMarketDetail': this.useLastMarketDetail} : null})
      .then(() => {});
  }

  onActive(event) {
    if (event.type === 'click') {
      event.cellElement.blur();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/base-data/components/company-detail/company-detail.component.ts